import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { AdContainer } from "../AdContainer";
import { AdSlotIds } from "@/shared/types";
import { CarouselAdCustomFallback } from "./CarouselAdCustomFallback";
import { useEffect } from "react";
import { useFarbwelt } from "@/hooks";
import { useAdsContext } from "../../context";
import { useIsPubstackEnabled } from "../../utils/utils";
import { getFeaturesEnabled } from "@/utils";
export const CarouselAd = () => {
    const { isFarbweltActive } = useFarbwelt();
    const { setLoadedSlot } = useAdsContext();
    const isPubstackEnabled = useIsPubstackEnabled();
    const { showOptionalAdsWithFarbwelt } = getFeaturesEnabled();
    const shouldShowAd = !isFarbweltActive || showOptionalAdsWithFarbwelt;
    useEffect(() => {
        if (shouldShowAd && isPubstackEnabled) {
            setLoadedSlot(AdSlotIds.AD_CAROUSEL, "loading");
            // eslint-disable-next-line no-restricted-globals
            window.dispatchEvent(new CustomEvent("admSPAReload"));
        }
    }, [shouldShowAd, isPubstackEnabled, setLoadedSlot]);
    return (_jsx(_Fragment, { children: _jsx(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", children: shouldShowAd ? (_jsx(AdContainer, { adSlotId: AdSlotIds.AD_CAROUSEL, width: "100%", height: "100%", display: "flex", dynamicSlot: true })) : (_jsx(CarouselAdCustomFallback, {})) }) }));
};
